// const LoginScreen = React.lazy(() => import('./login/LoginScreen'));
// const SplashScreen = React.lazy(() => import('./splash/SplashScreen'));
// const OTPScreen = React.lazy(() => import('./login/OTPScreen'));
// const CompleteProfile = React.lazy(() => import('./login/CompleteProfile'));
// const FlashMessage = React.lazy(() => import('react-native-flash-message'));
// const DashboardScreen = React.lazy(() => import('./dashboard/DashboardScreen'));
// const PrePurchaseAayuCard = React.lazy(() => import('./aayu-card/PrePurchaseAayuCard'));
// const EconsultCreated = React.lazy(() => import('./e-consult/EconsultCreated'));
// const PostPurchaseAayu = React.lazy(() => import('./aayu-card/PostPurchaseAayu'));
// const CategorySelection = React.lazy(() => import('./e-consult/CategorySelection'));
// const MemberSelection = React.lazy(() => import('./e-consult/MemberSelection'));
// const QuestionaireScreen = React.lazy(() => import('./e-consult/QuestionaireScreen'));
// const ProfileDetails = React.lazy(() => import('./profile-details/ProfileDetails'));
// const AddUpdateMember = React.lazy(() => import('./profile-details/AddUpdateMember'));
// const ConsultationList = React.lazy(() => import('./consultationView/ConsultationList'));
// const ServicePayment = React.lazy(() => import('./payment/ServicePayment'));
// const PaymentWithSubscription = React.lazy(() => import('./payment/ServicePaymentWithSubscription'));
// const AayuCardList = React.lazy(() => import('./payment/AayuCardList'));
// const AayuCardQuiz = React.lazy(() => import('./aayu-card/AayuCardQuiz'));
// const TransactionHistory = React.lazy(() => import('./profile-details/TransactionHistory'));
// const FirstConsultation = React.lazy(() => import('./consultationView/FirstConsultation'));
// const AayuCardRecommend = React.lazy(() => import('./aayu-card/AayuCardRecommend'));
// const ReviewAnswers = React.lazy(() => import('./e-consult/ReviewAnswers'));
// const PharmacyProfile = React.lazy(() => import('./pharmacy-profile/PharmacyProfile'));
// const ProductList = React.lazy(() => import('./pharmacy-profile/ProductList'));
// const ProductDetails = React.lazy(() => import('./pharmacy-profile/ProductDetails'));
// const LoginDashboard = React.lazy(() => import('./dashboard/LoginDashboard'));
// const MemberList = React.lazy(() => import('./profile-details/MemberList'));
// const SingleConsultView = React.lazy(() => import('./consultationView/SingleConsultationView'));
// const FirstConsultation = React.lazy(() => import('./profile-details/TransactionHistory'));

import SplashScreen from './splash/SplashScreen';
import LoginScreen from './login/LoginScreen';
import OTPScreen from './login/OTPScreen';
import CompleteProfile from "./login/CompleteProfile";
import FlashMessage from "react-native-flash-message";
import DashboardScreen from './dashboard/DashboardScreen';
import PrePurchaseAayuCard from './aayu-card/PrePurchaseAayuCard';
import EconsultCreated from "./e-consult/EconsultCreated";
import PostPurchaseAayu from "./aayu-card/PostPurchaseAayu";
import CategorySelection from "./e-consult/EConsultCategorySelection";
import MemberSelection from "./e-consult/MemberSelection";
import QuestionaireScreen from "./e-consult/QuestionaireScreen";
// import SimpleCard from "./SimpleCard";
import ProfileDetails from "./profile-details/ProfileDetails";
import AddUpdateMember from "./profile-details/AddUpdateMember";

import SingleConsultView from './consultationView/SingleConsultationView';

import ServicePayment from "./payment/ServicePayment";
import PaymentWithSubscription from "./payment/ServicePaymentWithSubscription";
import AayuCardList from "./payment/AayuCardList";
import AayuCardQuiz from "./aayu-card/AayuCardQuiz";

import ActivityList from './consultationView/ActivityList';
import OrderList from "./oms/OrderList";

import AayuCardRecommend from "./aayu-card/AayuCardRecommend";
import ReviewAnswers from "./e-consult/ReviewAnswers";
import MemberList from "./profile-details/MemberList";
import TransactionHistory from "./profile-details/TransactionHistory";

import FirstConsultation from "./consultationView/FirstConsultation";

import SearchText from "./oms/SearchMedcine";
import SearchLocality from "./oms/SearchLocality";
import ReviewOrder from "./oms/ReviewOrder";
import FetchOMSLocation from "./oms/FetchLocation";
import SelectType from "./oms/SelectType";

import PharmacyList from "./oms/PharmacyList";
import SelectedPharmacy from "./oms/SelectedPharmacy";
import SearchMedicineComponent from './oms/SearchMedcine';

import SearchDeals from "./inventory/SearchDeals";
import SelectedDealView from './inventory/SelectedDealView';

import OrderSummary from "./oms/OrderSummary";
import OrderDetails from "./oms/OrderDetails";
import MessageView from './oms/MessageView';
import OrderSuccess from "./oms/OrderSucess";

import CustomCheckout from "./payment/CustomCheckout";
import WalletNetBankingModesList from "./payment/WalletNetBankingModesList";
import OmsOffers from "./oms/OmsOffers";
import EnterDebitCreditDetails from "./payment/EnterDebitCreditDetails";
import PaymentSuccessOrFailed from "./payment/PaymentSuccessOrFailed";

import NotificationList from "./notification/ListNotification";
import OffersList from "./offer-rewards/OffersList";
import SelectedOfferView from "./offer-rewards/SelectedOfferView";
import RewardsScreen from "./offer-rewards/Rewards";

import UserAddressList from "./address/UserAddressList";
import UpsertUserAddress from "./address/UpsertUserSavedAddress";

import ChemistStoreProfile from './chemist/ChemistStoreProfile';

import ImagesPreview from './ImagesPreview/ImagesPreview'

import TabControllerScreen from "./TabControllerScreen";

import AppTheme from '../AppTheme';
import AppStyles from '../AppStyles';
import ProductCategories from './inventory/ProductCategoryList';

export {
  AppTheme, AppStyles,
  SplashScreen, LoginScreen, OTPScreen,
  ReviewOrder, SearchMedicineComponent,
  SearchLocality, OrderSuccess,
  QuestionaireScreen,
  FlashMessage, DashboardScreen, PrePurchaseAayuCard, EconsultCreated, PostPurchaseAayu, CategorySelection, MemberSelection,
  ProfileDetails, AddUpdateMember, SingleConsultView, ServicePayment,
  PaymentWithSubscription, AayuCardList, AayuCardQuiz, AayuCardRecommend, ReviewAnswers,
  MemberList, TransactionHistory, CompleteProfile, FirstConsultation,
  ActivityList, OrderList, FetchOMSLocation, SelectType, SearchText, PharmacyList, SelectedPharmacy,
  OrderSummary, OrderDetails, MessageView,
  WalletNetBankingModesList, OmsOffers, EnterDebitCreditDetails,
  CustomCheckout, PaymentSuccessOrFailed,
  NotificationList, OffersList, SelectedOfferView, RewardsScreen,
  UserAddressList, UpsertUserAddress,
  ChemistStoreProfile,
  ProductCategories as InventoryCategory, SearchDeals, SelectedDealView,
  ImagesPreview,
  TabControllerScreen
}